
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMoored as ObiMooredElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-moored.js';
 
 
 

 
 export const ObiMoored = createComponent({
   react: React,
   tagName: 'obi-moored',
   elementClass: ObiMooredElement,
   events: {
     
   }
  });
 
 